import React from 'react'
import Portfolio from '../components/portfolio/portfolio'

function PortfolioMain() {
	return <Portfolio />
}

export default PortfolioMain
